import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import type React from 'react';
import { BaseModal } from '../../common/UI/BaseModal';

interface AddSectionDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  onTitleChange: (value: string) => void;
  level: number;
  onLevelChange: (value: number) => void;
}

const AddSectionDialog: React.FC<AddSectionDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  onTitleChange,
  level,
  onLevelChange,
}) => {
  return (
    <BaseModal
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      title="Add New Section"
      actions={
        <>
          <Button onClick={onClose}>Cancel</Button>
          <Button onClick={onConfirm} variant="contained" disabled={!title.trim()}>
            Create Section
          </Button>
        </>
      }
    >
      <Stack spacing={2} sx={{ mt: 1 }}>
        <TextField
          label="Section Title"
          fullWidth
          value={title}
          onChange={(e) => onTitleChange(e.target.value)}
          autoFocus
        />
        <FormControl fullWidth>
          <InputLabel>Heading Level</InputLabel>
          <Select
            value={level}
            label="Heading Level"
            onChange={(e) => onLevelChange(Number(e.target.value))}
          >
            <MenuItem value={1}>Heading 1 (Main Section)</MenuItem>
            <MenuItem value={2}>Heading 2 (Sub-section)</MenuItem>
            <MenuItem value={3}>Heading 3</MenuItem>
          </Select>
        </FormControl>
        <Typography variant="caption" color="text.secondary">
          Note: The AI Assistant can help draft content for this section once created.
        </Typography>
      </Stack>
    </BaseModal>
  );
};

export default AddSectionDialog;
